import { createApp } from 'vue'
import App from './AboutStablePower.vue'

createApp(App).mount('#app-about-stable-power')
